import fileDownload from 'js-file-download'
import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Facility, FacilitySchedule, Hierarchy, Sku } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
interface ExportProps {
  fields: string[]
  guid?: string
}

class ScheduleAPI {
  api: API
  key = 'facility'

  constructor(api: API) {
    this.api = api
  }

  list = async (guid: string, config: CustomAxiosConfig = {}): Promise<FacilitySchedule> => {
    const response = await this.api.get(`/scheduling/facilities/${guid}/schedule`, config)
    return rawTransform(FacilitySchedule)(response.data)
  }

  patch = async (guid: string, data: any, config: CustomAxiosConfig = {}): Promise<FacilitySchedule> => {
    const response = await this.api.patch(`/scheduling/facilities/${guid}/schedule`, data, config)
    return rawTransform(FacilitySchedule)(response.data)
  }
}

class SkusAPI {
  api: API
  key = 'facility'

  constructor(api: API) {
    this.api = api
  }

  list = async (guid: string, config: CustomAxiosConfig = {}) => {
    const response = await this.api.get(`/logistics/facilities/${guid}/skus`, config)
    response.data = paginatedTransform(Sku)(response.data)
    return response.data
  }

}

export class Facilities {
  api: API
  key = 'facility'

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}) => {
    const response = await this.api.get('/logistics/facilities', config)
    response.data = paginatedTransform(Facility)(response.data)
    return response.data
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Facility> => {
    const response = await this.api.get(`/logistics/facilities/${guid}`, config)
    return rawTransform(Facility)(response.data)
  }

  hierarchy = async (guid: string, config: CustomAxiosConfig = { params: {} }) => {
    config.params.facilities = guid
    const response = await this.api.get('/logistics/places/hierarchy', config)
    return rawTransform(Hierarchy)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Facility> => {
    const response = await this.api.post('/logistics/facilities', data, config)
    return rawTransform(Facility)(response.data)
  }

  patch = async (guid: string, data: any, config: CustomAxiosConfig = {}): Promise<Facility> => {
    const response = await this.api.patch(`/logistics/facilities/${guid}`, data, config)
    return rawTransform(Facility)(response.data)
  }

  export = async ({ fields }: ExportProps) => {
    const params = { fields: fields.join(',') }
    const response = await this.api.axiosInstance({
      url: '/logistics/facilities/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'facilities.csv')
  }

  exportInventory = async ({ fields, guid }: ExportProps) => {
    const params = { fields: fields.join(',') }
    const response = await this.api.axiosInstance({
      url: `logistics/facilities/${guid}/inventory/export`, // to do: change for the right endpoint
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'inventoryReport.csv')
  }

  selectFacility(facility?: Facility | null) {
    localStorage.setItem('global-facility-filter', facility ? (facility.guid as string) : '')
  }

  getSelectedFacility() {
    return localStorage.getItem('global-facility-filter')
  }

  get skus() {
    const api = new SkusAPI(this.api)
    Object.defineProperty(this, 'skus', { value: api })
    return api
  }

  get schedule() {
    const api = new ScheduleAPI(this.api)
    Object.defineProperty(this, 'schedule', { value: api })
    return api
  }
}
